import React from "react";
import { ReturnedToSenderIA } from "./instantAnswersComponents/orders/ReturnedToSenderIA";
export var returnedToSender = function returnedToSender(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return RETURNED_TO_SENDER_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return RETURNED_TO_SENDER_DESCRIPTION();
    }
  };
};
var RETURNED_TO_SENDER_TITLE = function RETURNED_TO_SENDER_TITLE(strictLocalize) {
  return strictLocalize({
    id: "6yOxZh",
    defaultMessage: [{
      "type": 0,
      "value": "Devolvida ao remetente"
    }]
  });
};
var RETURNED_TO_SENDER_DESCRIPTION = function RETURNED_TO_SENDER_DESCRIPTION() {
  return /*#__PURE__*/React.createElement(ReturnedToSenderIA, null);
};